import React, { useContext } from 'react';
import { ThemeProvider } from '@material-ui/core';
import { ritzDataContext, selectProjectById, selectLoggedInAgent } from '@moderepo/mode-data-state-ritz';
import { modeSupportedThemes, modeThemeLight, ModeThemeType } from '@moderepo/mode-app-components';
import { Agent } from '@moderepo/mode-internal-apis';
import { useLocation } from 'react-router-dom';
import { useGetCurrentProjectId } from '../../utils/customHooks';

/**
 * This is a component in charge of switching app's theme base on the current selected project's settings.
 */
export const ModeThemeProvider: React.FC = ({ children }: React.PropsWithChildren<React.ReactNode>) => {
    const { state:dataState } = useContext(ritzDataContext);
    const location = useLocation();
    const projectId = useGetCurrentProjectId(location.pathname);
    const project = projectId ? selectProjectById(dataState, projectId) : undefined;
    const loggedInAgent = selectLoggedInAgent(dataState) as Agent;

    // Pick a theme base on the agent's settings. Use project theme then default theme if name is undefined or not a valid theme name
    const agentTheme = loggedInAgent && loggedInAgent.preferences && loggedInAgent.preferences.theme
        ? loggedInAgent.preferences.theme : undefined;

    const projectTheme = project && project.supportToolSettings
        ? project.supportToolSettings.theme : undefined;

    const theme = modeSupportedThemes[agentTheme || projectTheme || ModeThemeType.MODE_LIGHT]?.theme || modeThemeLight;

    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
};
